import {Injectable} from '@angular/core';
import { ToastService } from '../componentes/toast/toast.service';

/**
 * @author Felipe Leonhardt
 * http://www.vision-ti.com.br
 *
 * Serviço de mensagem do sistema
 */
@Injectable()
export class MessageService {

    constructor(private _toastService: ToastService){
    }
    public messages: Array<any> = [];

    public success(message: string) {
        this._toastService.show(message , 'success');
        // this.messages = [];
        // this.messages.push({severity: 'success', summary: 'Sucesso', detail: message});
    }

    public info(message: string) {
        this._toastService.show(message , 'info');
        // this.messages = [];
        // this.messages.push({severity: 'info', summary: 'Informação', detail: message});
    }

    public warn(message: string) {
        this._toastService.show(message , 'warning');
        // this.messages = [];
        // this.messages.push({severity: 'warn', summary: 'Atenção', detail: message});
    }

    public error(message: string) {
        this._toastService.show(message , 'error');
        // this.messages = [];
        // this.messages.push({severity: 'error', summary: 'Erro', detail: message});
    }
}